import { render, staticRenderFns } from "./ScriptoriumAutocompleteManuscriptText.vue?vue&type=template&id=607e7031&"
import script from "./ScriptoriumAutocompleteManuscriptText.vue?vue&type=script&lang=js&"
export * from "./ScriptoriumAutocompleteManuscriptText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports